export const FETCH_LOAD_ORGANISATION_REQUEST = 'FETCH_LOAD_ORGANISATION_REQUEST'
export const FETCH_LOAD_ORGANISATION_SUCCESS = 'FETCH_LOAD_ORGANISATION_SUCCESS'
export const FETCH_LOAD_ORGANISATION_FALUIRE = 'FETCH_LOAD_ORGANISATION_FALUIRE'
export const SEARCH_COMPANIES = 'SEARCH_COMPANIES'
